module.exports = __webpack_public_path__ + "static/media/red allianz-logo-long.d0a326b2.png";